import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { useCamera } from '../../../hooks/useCamera';
import { useStyles } from '../../../hooks/useStyles';
import { sidenavIsPinnedState } from '../../../storage/app';
import { capturingCurrentStateState, capturingState } from '../../../storage/streaming';
import CurrentStateActionModals from '../../currentState/modal/CurrentStateActionModals';
import CapturingVideo from '../../currentState/streaming/CapturingVideo';
import CapturingVideoDetail from '../../currentState/streaming/CapturingVideoDetail';
import { FloatingCardsLayout } from '../../layout/FloatingCardsLayout';
import { FloatingCardContent } from '../../layout/cards/FloatingCardContent';

function RequestVideoPage() {
  const { theme } = useStyles();
  const capturingCurrentState = useRecoilValue(capturingCurrentStateState);
  const setCapturing = useSetRecoilState(capturingState);
  const resetCapturing = useResetRecoilState(capturingState);
  const setSidenavIsPinned = useSetRecoilState(sidenavIsPinnedState);
  const { zoomTo } = useCamera();
  const { ident } = useParams();

  useEffect(() => {
    return () => {
      resetCapturing();
    };
  }, []);

  useEffect(() => {
    setSidenavIsPinned(false);
  }, []);

  useEffect(() => {
    setCapturing((prev) => ({
      ...prev,
      ident: ident,
    }));
  }, [ident]);

  useEffect(() => {
    if (capturingCurrentState) {
      const lng = capturingCurrentState.point.coordinates[0];
      const lat = capturingCurrentState.point.coordinates[1];
      if (lng && lat) zoomTo({ lng, lat });
    }
  }, [capturingCurrentState, zoomTo]);

  return (
    <>
      <FloatingCardsLayout
        contentSize={400}
        content={
          <FloatingCardContent
            flexible
            gap={theme.sizing.scale600}
          >
            <CapturingVideoDetail />
          </FloatingCardContent>
        }
      />
      <CapturingVideo />
      <CurrentStateActionModals />
    </>
  );
}

export default RequestVideoPage;
